/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonValidatorAddressSummaryInfo } from './BabylonValidatorAddressSummaryInfo';

export type BabylonValidatorDetailInfo = {
    VD: BabylonValidatorAddressSummaryInfo;
    STAT: BabylonValidatorDetailInfo.STAT;
    VP: string;
    VPVAL: string;
    VPP: string;
    TBND: string;
    TBNDVAL: string;
    SLFBND: string;
    SLFBNDVAL: string;
    SLFBNDP: string;
    CMS: string;
    MXR: string;
    MXCNGR: string;
    UT: string;
    MSDBLKCNT: string;
    WEB: string;
    DTL: string;
};

export namespace BabylonValidatorDetailInfo {

    export enum STAT {
        BONDED = 'BONDED',
        INACTIVE = 'INACTIVE',
        JAILED = 'JAILED',
    }


}

